module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-chalk-5-e0428f946f64fc17b01418ddf357c925.webp";